import {createSlotRecipeContext} from '@chakra-ui/react3'
import accordionSlotRecipe from './index.recipe'

const {StylesProvider, useStyles} = createSlotRecipeContext({
    recipe: accordionSlotRecipe
})

export {StylesProvider, useStyles}
